import React, {ReactElement, useEffect} from 'react';

import buddyLogo from './../../assets/images/logo_white background.svg';
import splashImage from './../../assets/images/splash.svg';
import {useAppSelector, useAppDispatch} from '../../redux/hooks';
import {useHistory} from 'react-router';
import {useLocation} from 'react-router-dom';
import {
  setStoreCode,
  getStoreCode,
  getAccessToken,
  setStoreInformation,
  setUserType,
} from '../../core/localstorage-data';
import {
  fetchStoreInformation,
  storeInformation,
} from '../../redux/storeInformationSlice';
import {
  HOME_ROUTE_PATH,
  LANDING_PATH,
  LOGIN_ROUTE_PATH,
} from '../../routes/route-constants';
import {setPageName} from '../../lib/tagmanager';
import {pageName} from '../../lib/constants';

const Splash = (): ReactElement => {
  const storeInformationData = useAppSelector(storeInformation);
  const dispatch = useAppDispatch();
  const navigate = useHistory();
  let store_input_code: string | null;
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };
  const query = useQuery();
  store_input_code = query.get('id');

  function checkTokenValidity(jwtPayload: {exp: number}) {
    if (Date.now() >= jwtPayload.exp * 1000) {
      return false;
    } else return true;
  }

  useEffect(() => {
    setPageName(pageName.splashScreen);
    const userTypeData = 'customer';
    setUserType(userTypeData);

    //check the availability of store code. 
    //cannot proceed further if it is not there
    if (getStoreCode() !== null) {
      store_input_code = getStoreCode();
    } else {
      console.log('here');
      navigate.replace(LANDING_PATH);
      return;
    }

    const accessToken = getAccessToken();
    if (accessToken !== null) {
      const jwtPayload = parseJwt(accessToken);
      const isAccessTokenValid = checkTokenValidity(jwtPayload);
      if (isAccessTokenValid) {
        const payload = {
          mobile_number: jwtPayload.phone,
          store_input_code,
        };
        dispatch(fetchStoreInformation(payload));
      } else {
        setTimeout(() => {
          navigate.replace(LOGIN_ROUTE_PATH);
        }, 2000);
      }
    } else if (!accessToken) {
      setTimeout(() => {
        navigate.replace(LOGIN_ROUTE_PATH);
      }, 2000);
    }
  }, []);

  useEffect(() => {
    if (storeInformationData !== null && storeInformationData.result === true) {
      setStoreInformation(storeInformationData);
      setTimeout(() => {
        navigate.replace(HOME_ROUTE_PATH);
      }, 2000);
    } else if (
      storeInformationData?.resultCode !== '' &&
      storeInformationData?.result === false
    ) {
      setTimeout(() => {
        navigate.replace(LOGIN_ROUTE_PATH);
      }, 2000);
    }
  }, [storeInformationData]);

  function parseJwt(token: string) {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join(''),
    );

    return JSON.parse(jsonPayload);
  }

  return (
    <div className="h-screen w-full py-4">
      <div className="px-4 flex justify-center flex-col h-80 items-center">
        <img src={buddyLogo} className="h-24 w-36" alt="Max Buddy" />
        <div className="text-xl text-center mt-3.5">
          <p>
            I&apos;m Max Buddy, your virtual assistant. Let&apos;s go shopping!
          </p>
        </div>
      </div>
      <div className="absolute bottom-0 right-0 left-0">
        <img src={splashImage} className="" alt="Max Buddy" />
      </div>
    </div>
  );
};

export default Splash;
